import type {Disposable, Environment} from 'relay-runtime';
import {commitMutation, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import type {
	StopAgenticWorkerRunInput,
	StopAgenticWorkerRunMutation,
} from './__generated__/StopAgenticWorkerRunMutation.graphql';
import type {MutationInput, RelayOnCompleted, RelayOnError} from '../MutationTypes';

const mutation = graphql`
	mutation StopAgenticWorkerRunMutation($input: StopAgenticWorkerRunInput!) {
		stopAgenticWorkerRun(input: $input) {
			run {
				id
				state
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<StopAgenticWorkerRunInput>,
	onSuccess?: RelayOnCompleted<StopAgenticWorkerRunMutation>,
	onError?: RelayOnError
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};
	return commitMutation<StopAgenticWorkerRunMutation>(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
